import type { DashboardFinanceiroParams } from "../types/financeiro-dashboard.types";

/** UI → API (`GET /loja/financeiro/*`). */
export const granularidadeParaApi: Record<
  NonNullable<DashboardFinanceiroParams["granularidade"]>,
  "dia" | "semana" | "mes" | "ano"
> = {
  diaria: "dia",
  semanal: "semana",
  mensal: "mes",
  anual: "ano",
};
